import { useTranslation } from "react-i18next";
import SuggestionList from "../../../ui/forms/SuggestionList";
import { suggestionKey, suggestionText, type Suggestion } from "./suggestions";

interface ComposerSuggestionListProps {
  id: string;
  suggestions: readonly Suggestion[];
  activeIndex: number;
  onChoose: (suggestion: Suggestion) => void;
}

/** The composer's suggestions above the field, each with its kind (F21). */
export default function ComposerSuggestionList({ id, suggestions, activeIndex, onChoose }: ComposerSuggestionListProps) {
  const { t } = useTranslation();
  if (suggestions.length === 0) return null;
  return (
    <SuggestionList
      id={id}
      label={t("threads.composer.suggestions.label")}
      items={suggestions}
      activeIndex={activeIndex}
      itemKey={suggestionKey}
      renderItem={(suggestion) => (
        <span className="flex min-w-0 items-baseline gap-2" title={suggestionText(suggestion)}>
          <span className="truncate font-medium">{suggestion.kind === "skill" ? suggestionText(suggestion) : suggestion.name}</span>
          <span className="app-text-muted shrink-0 text-xs">{t(`threads.composer.suggestions.kinds.${suggestion.kind}`)}</span>
        </span>
      )}
      onChoose={onChoose}
      placement="above"
    />
  );
}
